import { render } from "./IntroductionView.vue?vue&type=template&id=be0e5048"
import script from "./IntroductionView.vue?vue&type=script&lang=js"
export * from "./IntroductionView.vue?vue&type=script&lang=js"

import "./IntroductionView.vue?vue&type=style&index=0&id=be0e5048&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__